import { useI18n } from "../../i18n";
import { Globe, X } from "lucide-react";

export default function LocaleModal() {
  const { showModal, setLang, dismissModal, suggested, languages, t } = useI18n();
  if (!showModal) return null;

  const sug = languages.find((l) => l.code === suggested) || languages[0];
  const en = languages[0];

  return (
    <div data-testid="locale-modal"
      className="fixed inset-0 z-[90] grid place-items-center bg-black/85 backdrop-blur-md p-4">
      <div className="panel p-6 sm:p-8 max-w-md w-full relative" style={{ borderColor: "rgba(231,180,59,.45)" }}>
        <button onClick={dismissModal}
          className="absolute top-3 right-3 w-9 h-9 rounded-full grid place-items-center border border-[#23232a] hover:border-[color:var(--gold)]" aria-label="Close">
          <X className="w-4 h-4" />
        </button>
        <div className="w-12 h-12 rounded-xl grid place-items-center mb-4 sm:mb-5"
          style={{ background: "linear-gradient(135deg,#f5d06a,#8a6a15)" }}>
          <Globe className="w-6 h-6 text-[#141006]" />
        </div>
        <h3 className="font-display font-black text-xl sm:text-2xl mt-2 leading-tight">{t("locale_title")}</h3>
        <p className="text-[13px] sm:text-sm text-[color:var(--ink-dim)] mt-3 leading-relaxed">{t("locale_sub")}</p>

        <div className="mt-5 sm:mt-6 grid gap-3">
          <button onClick={() => setLang("en")} data-testid="locale-en"
            className="btn-gold h-12 rounded-xl flex items-center justify-between px-5 font-display">
            <span className="flex items-center gap-3">
              <span className="text-xl">{en.flag}</span>
              <span>{en.native}</span>
            </span>
            <span className="text-xs opacity-80">→</span>
          </button>
          {suggested !== "en" && (
            <button onClick={() => setLang(suggested)} data-testid="locale-regional"
              className="btn-ghost h-12 rounded-xl flex items-center justify-between px-5 font-display">
              <span className="flex items-center gap-3">
                <span className="text-xl">{sug.flag}</span>
                <span>{sug.native}</span>
              </span>
              <span className="text-xs opacity-80">→</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
